import { theme } from 'antd'

import { queryKindRankingApi } from '@eastcoal/api/trade/orderMember/queryKindRanking'

import { RemoteTable } from '@eastcoal/common/components/RemoteTable'

import { KindRankingListProps, KindRankingListTableProps } from './interface'

const designToken = theme.getDesignToken()
const RankingColors = [designToken.red6, designToken.blue6, designToken.yellow6]

const columns: KindRankingListTableProps['columns'] = [
  {
    dataIndex: '__index',
    title: '排名',
    align: 'center',
    render(_, __, index) {
      const bgColor = RankingColors[index] || '#ccc'
      return (
        <span
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: 20,
            height: 20,
            color: 'white',
            backgroundColor: bgColor
          }}
        >
          {index + 1}
        </span>
      )
    }
  },
  {
    dataIndex: 'kindName',
    title: '品种',
    align: 'center'
  },
  {
    dataIndex: 'totalQuantity',
    title: '成交量(吨)',
    align: 'right',
    valueType: 'digit'
  },
  {
    dataIndex: 'totalAmount',
    title: '成交额(元)',
    align: 'right',
    valueType: 'digit'
  }
]

export const KindRankingList = ({ kindCodes }: KindRankingListProps) => {
  return (
    <RemoteTable
      api={queryKindRankingApi}
      bordered={false}
      columns={columns}
      pagination={false}
      requestParams={{ kindCodes }}
      rowKey='kindId'
    />
  )
}
